import { MonitoringClient } from "@/app/(app)/monitoring/_components/monitoring-client";

export default function MonitoringPage() {
  return <MonitoringClient />;
}
